import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  const lowStock = Object.values(product.stock || {}).some((n) => n <= 5);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block bg-card border border-white/10 hover:border-kinetic/60 transition-colors duration-300"
      >
        <div className="relative overflow-hidden clipped-frame aspect-[4/5]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          {product.customizable && (
            <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] bg-kinetic text-white px-2 py-1">Customizable</span>
          )}
          {lowStock && (
            <span className="absolute top-3 right-3 font-mono text-[10px] uppercase tracking-[0.2em] bg-volt text-black px-2 py-1">Low Stock</span>
          )}
        </div>
        <div className="p-4 flex items-start justify-between gap-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{product.category}</p>
            <h3 className="font-bold uppercase tracking-wide text-sm mt-1 group-hover:text-kinetic transition-colors">{product.name}</h3>
          </div>
          <div className="text-right font-mono text-sm">
            {product.compare_at && <span className="block text-zinc-600 line-through text-xs">${product.compare_at.toFixed(2)}</span>}
            <span className="text-white">${product.price.toFixed(2)}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
